// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7xapm","col":"styles_col__1kGDh"};